module.exports = __webpack_public_path__ + "images/samsung-pay.4957222e6ce8e1fbbab6ba98a000ff07.svg";